export type VersionHistoryEntry = {
  version: string;
  releaseDate: string;
  title: string;
  summary: string;
  items: string[];
};

export const VERSION_HISTORY: VersionHistoryEntry[] = [
  {
    version: '1.18.0',
    releaseDate: '2026-05-18',
    title: 'Tema Kontrastı + Rapor Önizleme Modalı + Workiom Sadeleştirmesi',
    summary: 'Esnek rapor oluşturucudaki çift önizleme kaldırıldı, müşteri ve sipariş akışlarında görünürlük düzeltildi, Workiom görünürlüğü ve otomatik senkron davranışı sadeleştirildi.',
    items: [
      'Esnek Rapor Oluşturucu ekranında SQL önizleme sonucu yerleşik ikinci tablo yerine modal pencerede gösterilecek şekilde güncellendi; alan eşleştirme ekranı sayfada bırakıldı.',
      'Önizleme alındığında modal otomatik açılır hale getirildi; form sıfırlanınca veya farklı bir rapor düzenlemeye geçilince önizleme modalı kapanıyor.',
      'Sevk siparişi oluşturma ekranında fatura müşterisi seçim listesinin seçili ve hover durum kontrastı artırıldı.',
      'Sevk sihirbazındaki hızlı müşteri ekleme modalında telefon alanı zorunlu olmaktan çıkarıldı; firma adı ve il bilgisiyle kayıt yapılabiliyor.',
      'Müşteri Yönetimi tablo kontrastı iyileştirildi; grup başlıkları, sticky alanlar, hover durumları ve koyu tema tablo sınır renkleri yeniden dengelendi.',
      'Workiom ile ilgili görünür aksiyonlar ve kimlik alanları sadeleştirildi; ilgili ekranlarda kullanıcıya gösterilen Workiom butonları ve bazı görünür Workiom referansları kaldırıldı.',
      'Stokbar müşteri otomatik senkron planlayıcısı ortam değişkeni ile kapatılabilir hale getirildi; arka plan senkronu varsayılan olarak pasiflenebiliyor.',
    ],
  },
  {
    version: '1.17.0',
    releaseDate: '2026-05-13',
    title: 'Operasyon Yetkileri + Plan Kodu + Stokbar ve Mobil Akışlar',
    summary: 'Plan kodu, araç türü filtreleri, teslim onay akışı, sağ tık durum yönetimi, Stokbar müşteri/depo importları ve mobil belge/uyarı iyileştirmeleri eklendi.',
    items: [
      'Sevk siparişine Plan Kodu alanı eklendi; Tracking ve Supply listelerinde görünür hale getirildi, aramada kullanılabiliyor.',
      'Tracking ekranındaki tüm süreç sekmelerine plan kodu kolonu eklendi ve sağ tık menüsünden operasyonel ile muhasebe aşamaları manuel değiştirilebilir oldu.',
      'Araç türü çoklu seçim kuralları güçlendirildi; istenen araç türüne uymayan özmal/spot atamalar hem listede filtreleniyor hem backend tarafından reddediliyor.',
      'Kabul bekleyen görevlerde reddetme için red nedeni zorunlu hale getirildi; reddedince atama geri alınmıyor ve bildirim sebep bilgisiyle gidiyor.',
      'Sürücü ata ekranında özmal telefon kolonu eklendi, özmal/spot için yeni sürücü ekleme butonları kondu.',
      'Teslim onayı için Operasyon Sorumlusu akışı eklendi; teslim reddi sebep zorunlu, süreç teslim evrağı yükleme adımına dönebiliyor ve timeout sonrası otomatik onay scheduler ile destekleniyor.',
      'Boşaltma evrak akışı Teslim Tutanağı ve İade Tutanağı olarak ayrıldı; muhasebe ekranında bu evraklar ayrı etiketlerle gösteriliyor.',
      'Hammaliye, bekleme ve yatma bedeli alanları tedarik ve mobil muhasebe akışına bağlandı; genel toplam hesabına dahil edildi.',
      'Süper Admin yetkisi tanımlandı; silme, atamayı geri alma ve süreç geri alma işlemleri bu role özel hale getirildi.',
      'İç sürücüler için boş araç hareket uyarısı eklendi; aktif boş dönüş kaydı yoksa mobil ana ekranda uyarı gösteriliyor.',
      'Mobilde yüklenen sürücü/araç belgeleri admin tarafında artık görüntülenebiliyor.',
      'Spot sürücü atama listesi sadece başvuru kayıtlarına bağımlı olmaktan çıkarıldı; aktif dış sürücüler de görünür hale getirildi.',
      'Müşteri Yönetimi ekranına il/ilçe/mahalle sütunları ve filtreleri eklendi; Excel içe aktarma `musterilistesi-dogus.xlsx` formatına uyarlandı.',
      'Stokbar müşteri aktarımı 81 ili sırayla çekip ilerleme/önizleme gösteren yapıya çevrildi; mükerrer müşteri kayıtları cari kodu + isim + il + ilçe + adres anahtarıyla tekilleştiriliyor.',
      'Depo Yönetimi ekranına `type=warehouse` servisini kullanan Stokbar depo önizleme/aktarım butonu eklendi.',
      'Android push bildirimleri için varsayılan kanal metadata ve token kayıt akışı sertleştirildi; Tracking detayından sürücüye anlık SMS gönderme aksiyonu eklendi.',
    ],
  },
  {
    version: '1.16.0',
    releaseDate: '2026-05-02',
    title: 'Fatura Müşterisi + Optimizasyon Ayarları + Takip Düzeltmeleri',
    summary: 'Fatura müşteri seçimi arama listesi formatına çevrildi, optimizasyon ayarları kayıt altyapısı değiştirildi, takip ekranında yükleme ili ve fatura başlığı düzeltmeleri.',
    items: [
      'Sevk sihirbazında fatura müşteri seçimi, selectbox yerine arama destekli liste formatına çevrildi (başlangıç/bitiş noktasıyla aynı stil).',
      'Tracking "Atama Bekliyor" listesinde "YÜKLEME İLİ" kolonu koordinat yerine şehir ismi gösterecek şekilde düzeltildi.',
      'Tracking detay panelinin tüm bilgi sekmelerine (Bilgi, Yük, Sürücü) Fatura Başlığı alanı eklendi.',
      'Sevk siparişi oluşturulurken seçilen fatura müşterisinin adı artık fatura_basligi alanına doğru şekilde kaydediliyor.',
      'Sürücü atama modalındaki özmal ve spot maliyetler artık Ayarlar > Optimizasyon tablosundaki değerleri okuyor.',
      'Optimizasyon ayarları kayıt mantığı değiştirildi: tek büyük JSON yerine her alan ayrı satırda (optimization_ prefix) saklanıyor, request entity too large hatası giderildi.',
      'Ayarlar ve sevk sihirbazındaki sayı inputlarındaki spinner (yukarı/aşağı okları) kaldırıldı.',
      'Sevk sihirbazında yeni müşteri oluşturulduğunda fatura müşterisi olarak otomatik seçilmesi sağlandı.',
      'Settings > Optimizasyon formu kaydetme butonu çalışır hale getirildi.',
    ],
  },
  {
    version: '1.15.0',
    releaseDate: '2026-05-01',
    title: 'Muhasebe Evrak Akışı + Sevk Sihirbazı İyileştirmeleri',
    summary: 'Muhasebe ve takip ekranlarında evrak yönetimi güçlendirildi, sevk siparişi oluşturma sihirbazı varsayılanları ve son adımı iyileştirildi.',
    items: [
      'Dış tedarik muhasebe ekranında fatura ve dekont evrakları küçük kutucuklar halinde gösterilip tıklayınca büyütme modalı açılacak şekilde güncellendi.',
      'Ödeme bekleyen sevkiyatlar için tek dekontla çoklu sevkiyatı kapatmaya imkan veren toplu dekont yükleme akışı eklendi.',
      'Tracking detay panelinde fatura bekleyen, ödeme bekleyen ve ödemesi gerçekleşen adımları için eksik sürücü, takip ve evrak sekmeleri tamamlandı.',
      'Tracking > Evraklar alanında yükleme evrakları, teslim evrakları ve fatura görselleri küçük görsel kartlarla gösterilmeye başlandı.',
      'Ödemesi gerçekleşen adımının takip sekmesine ödeme tarihi ve ödeme dekontu gösterimi eklendi.',
      'Sevk siparişi oluşturma ekranında varsayılanlar güncellendi: sefer tipi komple, araç tipi Tır Tenteli Kayar Perde, yük türü Cips, hacim 70 m3, ağırlık 5 ton.',
      'Yük türü alanı tarayıcı datalist yerine uygulama içi alt seçim paneline çevrildi; manuel yazım kaldırıldı.',
      'Sevk siparişi oluşturma sihirbazının son adımı fiyat modu seçimi, tutar ayarları ve oluşturma özeti ile yeniden tasarlandı.',
      'Yeni açılan sevk siparişlerinin listede en üstte görünmesi için sıralama oluşturulma/güncellenme tarihine göre iyileştirildi.',
      'iOS görünümünde Google Play referansları gizlenerek App Store inceleme gereksinimlerine uyum sağlandı.',
    ],
  },
  {
    version: '1.14.0',
    releaseDate: '2026-04-29',
    title: 'Takip Sekmesi Genişletildi + Aşama Düzeltmesi',
    summary: 'Yükleme Bekliyor aşamasına Takip sekmesi eklendi, canlı bekleme süresi güncellemesi ve mobil aşama eşleme düzeltmesi.',
    items: [
      '"Yükleme Bekliyor" aşamasına "Takip" sekmesi eklendi (Yükleme Devam\'daki gibi varış saati, bekleme süresi).',
      '"Takip" sekmesinde canlı bekleme süresi güncellemesi (her dakika otomatik).',
      'Boşaltma aşamaları için de "Takip" sekmesi desteği (Boşaltma Bekliyor, Boşaltma Devam).',
      'Backend aşama eşleme düzeltildi: mapCurrentStageToProcessStatus mobilize aşamalarla uyumlu hale getirildi.',
      'WAITING_STAGE_CONFIG mobil aşama numaralarıyla güncellendi (2,3,4 ve 7,8,9).',
      'LiveTracking sayfasına "Atandı İşlem Bekliyor" aşaması eklendi (9 aşamalı mobil akış).',
      '"Sürücü" sekmesi "Atandı İşlem Bekliyor" ve "Yükleme Bekliyor" aşamalarına eklendi.',
      '"Yükleme Tamam" aşamasına "Sürücü" ve "Takip" sekmeleri eklendi.',
      'Takip sekmesinde; varış, başlama, bitiş zamanları, beklemeli/beklemesiz yükleme süresi gösterimi.',
      'Yükleme tamamlandı evrakı (completion document) Takip sekmesinde görüntülenebiliyor.',
      'TrackingTabContent bileşeni ile aşamaya göre dinamik içerik gösterimi.',
    ],
  },
  {
    version: '1.13.0',
    releaseDate: '2026-04-28',
    title: 'Optimizasyon Ayarları + Müşteri Filtreleme',
    summary: 'Workiom entegrasyonu ile spot maliyet hesaplama, müşteri tablosunda gelişmiş filtreleme ve sıralama.',
    items: [
      'Settings > Optimizasyon sekmesi eklendi.',
      'Workiom API\'den spot tedarik kayıtları çekilerek ortalama km maliyeti hesaplama.',
      'Özmal Araç KM Maliyeti ve Spot Araç KM Maliyeti ayarları.',
      'Ortalama Araç Hızı (km/saat) ayarı eklendi.',
      'Müşteri yönetiminde alanlara göre filtreleme (Müşteri Tipi, Durum, İl, İlçe, Ad, VKN).',
      'Müşteri yönetiminde kolon başlıklarına tıklayarak sıralama (A-Z / Z-A).',
      'Müşteri tablosunda aktif filtre sayısı ve temizleme butonu.',
    ],
  },
  {
    version: '1.12.0',
    releaseDate: '2026-04-27',
    title: 'Müşteri Yönetimi + Mobil Yönlendirme',
    summary: 'Gelişmiş müşteri tablosu, mobil uygulama indirme yönlendirmesi.',
    items: [
      'Müşteri yönetiminde toplu seçim ve toplu işlemler (Aktif/Pasif/Sil).',
      'Müşteri tablosuna sayfalama eklendi.',
      'Settings sayfasına Google Play ve App Store URL alanları eklendi.',
      'Driver-mobile-auth sayfasına mobil uygulama indirme popupı eklendi.',
      'İşletim sistemi tespiti (android/ios) eklendi.',
      'TestStokbar sayfası eklendi (API test için).',
    ],
  },
  {
    version: '1.11.0',
    releaseDate: '2026-04-27',
    title: 'Stokbar Entegrasyonu',
    summary: 'Stokbar yazılımından müşteri aktarımı ve çeşitli iyileştirmeler.',
    items: [
      'Stokbar müşteri entegrasyonu eklendi.',
      'Müşteri yönetiminden Stokbar aktarım butonu eklendi.',
    ],
  },
  {
    version: '1.10.0',
    releaseDate: '2026-04-27',
    title: 'Yedekleme Sistemi ve İyileştirmeler',
    summary: 'Veritabanı yedekleme sistemi, destek formu ve Workiom sync iyileştirmeleri.',
    items: [
      'Veritabanı yedekleme sistemi ve admin paneli eklendi.',
      'Otomatik yedekleme özelliği (cron tabanlı).',
      'Login olmadan erişilebilen destek iletişim formu (/contact).',
      'Workiom sync hata ayıklaması iyileştirildi.',
    ],
  },
  {
    version: '1.9.0',
    releaseDate: '2026-04-27',
    title: 'Destek ve Güvenlik',
    summary: 'Genel destek formu, şifre yönetimi iyileştirmeleri ve güvenlik güncellemeleri.',
    items: [
      'Login olmadan erişilebilen destek iletişim formu eklendi.',
      'Kullanıcı yönetiminde şifre doğrulama iyileştirildi.',
      'Rol sütunu veritabanı genişletildi.',
    ],
  },
  {
    version: '1.8.0',
    releaseDate: '2026-04-27',
    title: 'Operasyon ve Teklif Akışları',
    summary: 'Operasyon takip, teklif portalı, bekleme kayıtları ve tedarik yönetimi akışları güçlendirildi.',
    items: [
      'Operasyon Takip ekranına atama bekleyen, süreç pager ve süreç bazlı aksiyonlar eklendi.',
      'Özmal ve spot sürücü atama ekranları arama, konum ve yüklemeye uzaklık bilgileriyle geliştirildi.',
      'Workiom tekliflerinin bizim teklif kayıtlarına yazılması ve en düşük teklif hesabına dahil edilmesi sağlandı.',
      'Bekleme kayıtları için ticket durumu ve SLA özet alanları eklendi.',
      'Tedarik Yönetimi ve Operasyon Takip ekranlarının görsel dili iyileştirildi.',
    ],
  },
  {
    version: '1.7.0',
    releaseDate: '2026-04-20',
    title: 'Mobil ve Bildirim İyileştirmeleri',
    summary: 'Mobil sürücü ve teklif bildirim akışları iyileştirildi.',
    items: [
      'Teklif onay/red bildirimleri düzeltildi.',
      'Android tarafında teklif detay ve bildirim izin akışları iyileştirildi.',
      'Sürücü sevkiyat takip ekranında tahliye problemi bildirimi eklendi.',
    ],
  },
  {
    version: '1.6.0',
    releaseDate: '2026-04-10',
    title: 'Tedarik ve Workiom Senkronu',
    summary: 'Workiom ve tedarik senkronizasyon davranışları sadeleştirildi.',
    items: [
      'Workiom tedarik senkronu sadece teklif topla durumundaki kayıtlarla sınırlandı.',
      'Minimum teklif bedeli görünümü ve doğrulamaları kaldırıldı.',
      'Teklif taleplerinde süreçten çıkarma ve iptal davranışları düzeltildi.',
    ],
  },
];
